import { nullFunction } from 'utils';
import actionCreator from 'utils/actionCreator';

export const actions = actionCreator('web', [
  'RESET',
  'ADD_WEB_PAGE',
  'ADD_IMAGE',
  'ALL_PAGES_REQUEST',
  'ALL_PAGES_SUCCESS',
  'PAGE_SUCCESS',
  'CURRENT_VERSION_REQUEST',
  'CURRENT_VERSION_SUCCESS',
  'DELETE_PAGE',
  'RESTORE_PAGE',
  'UPDATE_PAGE_TITLE',
  'ADD_COMMENT',
  'EDIT_COMMENT',
  'EDIT_COMMENT_POSITION',
  'DELETE_COMMENT',
  'RESOLVE_COMMENT',
  'SHOW_LOADING',
  'HIDE_LOADING',
  'TOGGLE_VERSION_LOADING',
  'UPDATE_VERSION_CHANGES',
  'CANCEL_PAGE_VERSION_LISTENER',
  'CANCEL_PAGES_LISTENER',
  'TOGGLE_PAGE_APPROVAL',
  'DELETE_INSPECT_CHANGE',
  'DELETE_PAGE_VERSION',
  'RENAME_PAGE_VERSION',
  'TOGGLE_CHANGE_RESOLVE',
  'UPDATE_ASANA_COMMENT',
  'UPDATE_ASANA_EDIT',
  'DELETE_ASANA_COMMENT',
  'DELETE_ASANA_EDIT',
  'UPDATE_TRELLO_COMMENT',
  'UPDATE_TRELLO_EDIT',
  'DELETE_TRELLO_COMMENT',
  'DELETE_TRELLO_EDIT',
  'FIND_SIMILAR_PAGES',
  'SORT_PAGES',
  'PUSH_PAGES_CREATING',
  'POP_PAGES_CREATING',
  'DELETE_VIDEO',
  'REMOVE_ATTACHMENT',
  'UPDATE_ALL_PAGE_VERSIONS',
]);

export function resetWeb() {
  return {
    type: actions.RESET,
  };
}

export function addWebPage(payload, callback, navigate) {
  return {
    type: actions.ADD_WEB_PAGE,
    payload,
    callback,
    navigate,
  };
}

export function addImage(payload, callback = nullFunction, navigate) {
  return {
    type: actions.ADD_IMAGE,
    payload,
    callback,
    navigate,
  };
}

export function allPagesRequest(payload, navigate) {
  return {
    type: actions.ALL_PAGES_REQUEST,
    payload,
    navigate,
  };
}

export function allPagesSuccess(payload) {
  return {
    type: actions.ALL_PAGES_SUCCESS,
    payload,
  };
}

export function pageSuccess(payload) {
  return {
    type: actions.PAGE_SUCCESS,
    payload,
  };
}

export function currentVersionRequest(payload, navigate) {
  return {
    type: actions.CURRENT_VERSION_REQUEST,
    payload,
    navigate,
  };
}

export function currentVersionSuccess(payload) {
  return {
    type: actions.CURRENT_VERSION_SUCCESS,
    payload,
  };
}

export function updateVersionChanges(payload, callback) {
  return {
    type: actions.UPDATE_VERSION_CHANGES,
    payload,
    callback,
  };
}

export function deletePage(payload) {
  return {
    type: actions.DELETE_PAGE,
    payload,
  };
}

export function restorePage(payload) {
  return {
    type: actions.RESTORE_PAGE,
    payload,
  };
}

export function updatePageTitle(payload) {
  return {
    type: actions.UPDATE_PAGE_TITLE,
    payload,
  };
}

export function addComment(payload, callback = nullFunction) {
  return {
    type: actions.ADD_COMMENT,
    payload,
    callback,
  };
}

export function resolveComment(payload) {
  return {
    type: actions.RESOLVE_COMMENT,
    payload,
  };
}

export function editComment(payload) {
  return {
    type: actions.EDIT_COMMENT,
    payload,
  };
}

export function editCommentPosition(payload) {
  return {
    type: actions.EDIT_COMMENT_POSITION,
    payload,
  };
}

export function deleteComment(payload) {
  return {
    type: actions.DELETE_COMMENT,
    payload,
  };
}

export function showLoading(payload) {
  return {
    type: actions.SHOW_LOADING,
    payload,
  };
}

export function hideLoading() {
  return {
    type: actions.HIDE_LOADING,
  };
}

export function toggleVersionLoading(payload) {
  return {
    type: actions.TOGGLE_VERSION_LOADING,
    payload,
  };
}

export function cancelPageVersionListener() {
  return {
    type: actions.CANCEL_PAGE_VERSION_LISTENER,
  };
}

export function cancelPagesListener() {
  return {
    type: actions.CANCEL_PAGES_LISTENER,
  };
}

export function togglePageApproval() {
  return {
    type: actions.TOGGLE_PAGE_APPROVAL,
  };
}

export function deleteInspectChange(payload) {
  return {
    type: actions.DELETE_INSPECT_CHANGE,
    payload,
  };
}

export function deletePageVersion(payload, navigate) {
  return {
    type: actions.DELETE_PAGE_VERSION,
    payload,
    navigate,
  };
}

export function renamePageVersion(payload) {
  return {
    type: actions.RENAME_PAGE_VERSION,
    payload,
  };
}

export function toggleChangeResolve(payload) {
  return {
    type: actions.TOGGLE_CHANGE_RESOLVE,
    payload,
  };
}

export function updateAsanaComment(payload, callback) {
  return {
    type: actions.UPDATE_ASANA_COMMENT,
    payload,
    callback,
  };
}

export function updateAsanaEdit(payload, callback) {
  return {
    type: actions.UPDATE_ASANA_EDIT,
    payload,
    callback,
  };
}

export function updateTrelloComment(payload, callback) {
  return {
    type: actions.UPDATE_TRELLO_COMMENT,
    payload,
    callback,
  };
}

export function updateTrelloEdit(payload, callback) {
  return {
    type: actions.UPDATE_TRELLO_EDIT,
    payload,
    callback,
  };
}

export function deleteAsanaComment(payload, callback) {
  return {
    type: actions.DELETE_ASANA_COMMENT,
    payload,
    callback,
  };
}

export function deleteAsanaEdit(payload, callback) {
  return {
    type: actions.DELETE_ASANA_EDIT,
    payload,
    callback,
  };
}

export function deleteTrelloComment(payload, callback) {
  return {
    type: actions.DELETE_TRELLO_COMMENT,
    payload,
    callback,
  };
}

export function deleteTrelloEdit(payload, callback) {
  return {
    type: actions.DELETE_TRELLO_EDIT,
    payload,
    callback,
  };
}

export function findSimilarPages(payload) {
  return {
    type: actions.FIND_SIMILAR_PAGES,
    payload,
  };
}

export function sortPages(payload) {
  return {
    type: actions.SORT_PAGES,
    payload,
  };
}

export function pushPagesCreating(payload) {
  return {
    type: actions.PUSH_PAGES_CREATING,
    payload,
  };
}

export function popPagesCreating(payload) {
  return {
    type: actions.POP_PAGES_CREATING,
    payload,
  };
}

export function deleteVideo(payload) {
  return {
    type: actions.DELETE_VIDEO,
    payload,
  };
}

export function removeAttachment(payload) {
  return {
    type: actions.REMOVE_ATTACHMENT,
    payload,
  };
}

export function updateAllPageVersions() {
  return {
    type: actions.UPDATE_ALL_PAGE_VERSIONS,
  };
}
